import React from 'react';
import { Link } from 'react-router-dom';
import Services from '../../api/service';
import './ServiceSidebar.css'; // veya stilleri projenize uygun şekilde ekleyin

const ServiceSidebar = ({ currentService }) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <div className="col-lg-4 col-md-8">
            <div className="service-sidebar">
                {/* Hizmetler Listesi - Profesyonel Kart */}
                <div className="sidebar-widget services-widget">
                    <h3 className="widget-title">Hizmetlerimiz</h3>
                    <ul className="services-list">
                        {Services.slice(0, 6).map((service, index) => (
                            <li key={index} className={currentService?.Id === service.Id ? 'active' : ''}>
                                <Link onClick={ClickHandler} to={`/service-single/${service.Id}`}>
                                    <span className="service-icon">
                                        <i className={`fi ${service.icon}`}></i>
                                    </span>
                                    <span className="service-title">{service.sTitle}</span>
                                    <span className="service-arrow">
                                        <i className="fa fa-arrow-right"></i>
                                    </span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* İletişim Widget'ı - Servise Özel Profesyonel Kart */}
                {currentService && (
                    <div className="sidebar-widget contact-widget">
                        <h3 className="widget-title">{currentService.sTitle} İletişim</h3>
                        <div className="contact-details">
                            <div className="contact-item">
                                <div className="contact-icon">
                                    <i className="fa fa-phone"></i>
                                </div>
                                <div className="contact-info">
                                    <span className="contact-label">Telefon</span>
                                    <a href={`tel:${currentService.contactPhone}`} className="contact-value">
                                        {currentService.contactPhone}
                                    </a>
                                </div>
                            </div>
                            <div className="contact-item">
                                <div className="contact-icon">
                                    <i className="fa fa-instagram"></i>
                                </div>
                                <div className="contact-info">
                                    <span className="contact-label">Instagram</span>
                                    <a
                                        href={`https://instagram.com/${currentService.contactInstagram.replace('@', '')}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="contact-value"
                                    >
                                        {currentService.contactInstagram}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ServiceSidebar;